import { CurrencyPipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { HorizontalListData, HorizontalListFactory, ProductCode } from "common";
import { SalesforceUrlPipe } from "../../shared/pipes/salesforce-url.pipe";
import { AccountWithRenewalData } from "../account.model";

@Injectable()
export class AccountProfileAdapter {
  constructor(
    private readonly currencyPipe: CurrencyPipe,
    private readonly salesforceUrlPipe: SalesforceUrlPipe,
  ) { }

  adaptListData = (account: AccountWithRenewalData): HorizontalListData[] => {
    return [
      HorizontalListFactory.createInfoStringItem({
        displayedValue: account?.description,
        isItemHidden: account?.productCode !== ProductCode.Law
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Case number',
        displayedValue: account?.externalId,
        isItemHidden: account?.productCode !== ProductCode.Law
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Policy number',
        displayedValue: account?.policyNumber,
        isItemHidden: account?.productCode !== ProductCode.Law
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Policy limit',
        displayedValue: this.currencyPipe.transform(account?.policyLimit, "$"),
        isItemHidden: account?.productCode !== ProductCode.Law
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Loan number',
        displayedValue: account?.loanNumber
      }),
      HorizontalListFactory.createKeyValueExternalLinkItem({
				title: 'Salesforce Loan ID',
				displayedValue: account?.uniqueId,
				externalLink: this.salesforceUrlPipe.transform(account?.uniqueId),
				isValueHidden: !account?.uniqueId
			}),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Application number',
        displayedValue: account?.applicationNumber
      }),
      HorizontalListFactory.createKeyValueExternalLinkItem({
				title: 'Salesforce Application ID',
				displayedValue: account?.applicationUniqueId,
				externalLink: this.salesforceUrlPipe.transform(account?.applicationUniqueId),
				isValueHidden: !account?.applicationUniqueId
			}),
    ]
  }
}